"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _AgreementV = require("./AgreementV2");
Object.keys(_AgreementV).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _AgreementV[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _AgreementV[key];
    }
  });
});